// Build-time product flag. Set REACT_APP_PRODUCT=skonto for the Skonto build,
// REACT_APP_PRODUCT=dienstplan (or leave unset) for the Dienstplan build.
export type Product = 'dienstplan' | 'skonto';

export const PRODUCT: Product =
  (process.env.REACT_APP_PRODUCT as Product) || 'dienstplan';

export const BRAND = {
  dienstplan: {
    name: 'Dienstplan AI',
    subtitle: 'Vujicic Gastro GmbH',
    tagline: 'Personalplanung mit KI',
    primaryColor: undefined as string | undefined, // use theme default
  },
  skonto: {
    name: 'Skonto',
    subtitle: 'Wareneinsatz im Griff',
    tagline: 'Lieferantenpreise vergleichen, Überzahlungen vermeiden',
    primaryColor: undefined as string | undefined,
  },
}[PRODUCT];

export const isProduct = (p: Product) => PRODUCT === p;
